import { render } from "./FDFooter.vue?vue&type=template&id=0de8da59"
import script from "./FDFooter.vue?vue&type=script&lang=js"
export * from "./FDFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__